module.exports = __webpack_public_path__ + "../resources/img/ic_scan_default.cd46d875.svg";